import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Plus = forwardRef<SVGSVGElement, SvgIconProps>(function Plus(props, ref) {
  return (
    <SvgIcon ref={ref} {...props}>
      <polygon
        points="13.3457273 8.5939697 8.5939697 8.5939697 8.5939697 13.3457273 7.4060303 13.3457273 7.4060303 8.5939697 2.65427273 8.5939697 2.65427273 7.4060303 7.4060303 7.4060303 7.4060303 2.65427273 8.5939697 2.65427273 8.5939697 7.4060303 13.3457273 7.4060303"
        transform="translate(4, 4)"
      />
    </SvgIcon>
  )
})

export default Plus
